import React from "react";

import PlanItems from "components/PlanItems";

interface Props {
  items?: {
    id: number;
    name: string;
    description: string;
    provides: [];
    cost_ones: string;
    cost_monthly: string;
    on_sale: string;
    start_trial_url: string;
  }[];
  windowWidth: number;
  planDescription: any;
  planInfoText: any;
}

interface State {
  planUrlCounter: string[];
}

class Plan extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      planUrlCounter: [
        process.env.React_App_STARTTRIAL_BASIC as string | "",
        process.env.React_App_STARTTRIAL_PROFESSIONAL as string | "",
        process.env.React_App_STARTTRIAL_CORPORATE as string | "",
      ],
    };
  }

  render() {
    return (
      <>
        {this.props.items &&
          this.props.items.map((plan: any, index: number) => {
            return (
              <PlanItems
                key={plan.id}
                windowWidth={this.props.windowWidth}
                planDescription={this.props.planDescription}
                id={plan.id}
                name={plan.name}
                description={plan.description}
                provides={plan.provides}
                cost_ones={plan.cost_ones}
                cost_monthly={plan.cost_monthly}
		on_sale={plan.on_sale}
                start_trial_url={plan.start_trial_url}
                planUrlCounter={this.state.planUrlCounter[index]}
                planInfoText={this.props.planInfoText}
              />
            );
          })}
      </>
    );
  }
}

export default Plan;
